export default "__VITE_ASSET__TavXhkQx__ 640w, __VITE_ASSET__Dnb8$Zjo__ 1024w, __VITE_ASSET__8U$4C8yQ__ 1920w";